module.exports = __webpack_public_path__ + "static/image/history/m/201803_2.ver2_0_2.gif?2758b98a";